import React from "react";
import { ButtonDataType } from "../types";
import { LinkButton } from "./LinkButton";
import { cn } from "@/lib/utils";

interface ButtonGroupProps {
  items: ButtonDataType[];
  className?: string;
  /** Доп. классы на каждую кнопку (например форма CTA в hero по макету). */
  itemClassName?: string;
}

export function ButtonGroup({ items, className, itemClassName }: ButtonGroupProps) {
  return (
    <div className={cn("flex flex-row gap-6", className)}>
      {items.map((item, i) => (
        <LinkButton key={i} {...item} className={cn(itemClassName)} />
      ))}
    </div>
  );
}
